<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><i>To Alois and Elisabeth</i></p>
<p class="dedication">and to their twin daughters, Artemis and Lilith, who were conceived at the time this seminar was given</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_dedication.vue?7160292c